import React from 'react';
import { reactLocalStorage } from 'reactjs-localstorage';
import { FaPencilAlt, FaTrash } from 'react-icons/fa';
import Table from 'react-bootstrap/Table';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

import ModulAPI from '../../../api/ModulAPI';
import Const from '../../../util/Constants';
import withRouter from '../../../util/WithRouter';
import Util from '../../../util/Util';
import Display from '../../../util/Display';
import ApiUiController from '../../../controller/ApiUiController';

class OptionList extends React.Component {

  constructor(props) {
    super(props);
    this.state = { inApiCall: true, popup: false, name: '', option_order: 0 };
    this.fieldId = parseInt(props.match.params.fieldId);
    this.options = [];
    this.i = -1;

    let model = reactLocalStorage.getObject(Const.Model);
    const keys = Object.keys(model);
    for (let i = 0; i < keys.length; i++) {
      const fields = model[keys[i]].fields;
      if (fields === undefined) continue;
      const fieldKeys = Object.keys(fields);
      let j = 0;
      this.moduleName = model[keys[i]].model_name;
      for (; j < fieldKeys.length; j++) {
        if (parseInt(fields[fieldKeys[j]].id) === this.fieldId) {
          this.fieldName = fields[fieldKeys[j]].label_name;
          break;
        }
      }
      if (j < fieldKeys.length) break;
    }

    model = model.field_option;
    this.List = Util.isAllow(model.permission, Const.PermView);
    this.Add = Util.isAllow(model.permission, Const.PermAdd);
    this.Update = Util.isAllow(model.permission, Const.PermUpdate);
    this.Delete = Util.isAllow(model.permission, Const.PermDelete);
  }

  componentDidMount() {
    if (this.List) ModulAPI.listOption(this.fieldId, this.onReceived, this.onFail);
  }
  onFail = (res) => {
    const message = res.message ? JSON.stringify(res.message) : 'Something went wrong';
    Util.showError(message);
    this.setState({ ...this.state, inApiCall: false });
  };
  onReceived = options => { this.options = options; this.setState({ inApiCall: false }); };

  show = i => {
    this.i = i;
    const name = i !== -1 ? this.options[i].name : '';
    const fieldOrder = i !== -1 ? this.options[i].option_order : 0;
    this.setState({ ...this.state, name: name, option_order: fieldOrder, popup: true });
  };
  hide = () => this.setState({ ...this.state, popup: false });
  nameChange = event => this.setState({ ...this.state, name: event.target.value });
  orderChange = event => this.setState({ ...this.state, option_order: event.target.value });

  submit = () => {
    this.setState({ ...this.state, popup: false });
    const title = this.i !== -1 ? 'Rename' : 'Add';
    const message = this.i !== -1 ? `Are you sure you want to change name to ${this.state.name}`
      : `Are you sure you want to change name to ${this.state.name}`;
    Util.confirmAlert(title, message, title, 'No',
      () => {
        this.setState({ ...this.state, inApiCall: true });
        let option;
        if (this.i !== -1) {
          option = { ...this.options[this.i], name: this.state.name, option_order: this.state.option_order };
        } else {
          option = { id: 0, field_id: this.fieldId, name: this.state.name, option_order: this.state.option_order };
        }
        ModulAPI.saveOption(option, this.onSuccess, this.onFail);
      });
  };
  onSuccess = () => {
    Util.showNotification('Successful', 'Option saved successfully.', 'success');
    ModulAPI.listOption(this.fieldId, this.onReceived, this.onFail);
  };

  delete = i => {
    Util.confirmAlert('Delete', `Are you sure you want to delete ${this.options[i].name}`,
      'Delete', 'No', () => {
        this.setState({ ...this.state, inApiCall: true });
        ModulAPI.deleteOption(this.options[i].id, this.onDeleteSuccess, this.onFail);
      });
  };
  onDeleteSuccess = () => {
    Util.showNotification('Successful', 'Delete successfully.', 'success');
    this.props.onModuleChanged();
    ModulAPI.listOption(this.fieldId, this.onReceived, this.onFail);
  };

  render() {
    if (!this.List) return null;
    const optionUI = this.options.map((option, _i) => (
      <tr key={`module_${_i + 1}`}>
        <td>{_i + 1}</td>
        <td>{option.name}</td>
        <td>{option.value}</td>
        <td>{option.option_order}</td>
        <td>{Display.ModelLabelValue('user', option.created_by)}</td>
        <td>{Util.serverStringToDisplayDateTime(option.created_date)}</td>
        <td>{Display.ModelLabelValue('user', option.updated_by)}</td>
        <td>{Util.serverStringToDisplayDateTime(option.updated_date)}</td>
        <td>
          {this.Update &&
            <span className="buttons update" onClick={() => this.show(_i)} >
              <FaPencilAlt /> Rename
            </span>
          }
          {option.status !== Const.AlwaysActive && this.Delete &&
            <span className="buttons delete" onClick={() => this.delete(_i)} >
              <FaTrash /> Delete
            </span>
          }
        </td>
      </tr>
    ));

    return (
      <>
        <Modal
          show={this.state.popup}
          onHide={this.hide}
          size="md" aria-labelledby="contained-modal-title-vcenter" centered>
          <Modal.Header closeButton>
            <Modal.Title id="contained-modal-title-vcenter"> {this.fieldName} Option </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form>
              <Row className="row-cols-2 colmr">
                <Col xs={12}>
                  <Form.Label>Name</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Name"
                    className="mr-sm-2"
                    value={this.state.name}
                    onChange={this.nameChange} />
                </Col>
              </Row>
              <Row className="row-cols-2 colmr">
                <Col xs={12}>
                  <Form.Label>Order</Form.Label>
                  <Form.Control
                    type="number"
                    placeholder="Order"
                    className="mr-sm-2"
                    value={this.state.option_order}
                    onChange={this.orderChange} />
                </Col>
              </Row>
            </Form>
          </Modal.Body>
          <Modal.Footer> <Button onClick={this.submit}>Submit</Button> </Modal.Footer>
        </Modal>

        <div className="sectionlist pt-3">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-8"> <h3>
                {this.moduleName} - {this.fieldName} Option List</h3>
              </div>
              {this.Add &&
                <div className="col-md-4 text-right">
                  <span className="buttons update " onClick={() => this.show(-1)} >
                    + Add Option</span>
                </div>
              }

              <div className="col-md-12">
                <Table striped bordered hover>
                  <thead>
                    <tr>
                      <th>No</th>
                      <th>Name</th>
                      <th>Value</th>
                      <th>Order</th>
                      <th>Created By</th>
                      <th>Created Date</th>
                      <th>Updated By</th>
                      <th>Updated Date</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <ApiUiController inApiCall={this.props.inApiCall}>
                      {optionUI}
                    </ApiUiController>
                  </tbody>
                </Table>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}
export default withRouter(OptionList);